<template>
  <div>
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      v-model="visible"
      title="Add / Update Attendance"
      onOk="handleSubmit"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Save Attendance</a-button>
      </template>
      <a-spin :spinning="spinning">
        <p class="text-muted mb-4">Enter total school days and attendance for each student.</p>

        <div class="row mb-3" v-if="examData">
          <div class="col-12 col-md-8">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-2 text-nowrap"><strong>Total School Days:</strong></label>
              <a-input
                type="number"
                v-model="globalTotalSchoolDays"
                placeholder="Enter days"
                style="width: 150px"
              />
              <a-button type="primary" @click="applyGlobalTotalSchoolDays" class="ml-2">Apply to All</a-button>
            </div>
            <small class="text-muted">Set total school days for all students.</small>
          </div>
        </div>

        <a-form class="mb-4" :form="form">
          <div class="row neo-exam-attendance-form-table-container" v-if="examData">
            <div class="col-12 col-md-12 col-lg-12">
              <table class="table table-bordered w-100">
                <thead>
                  <th style="width: 6%;">Sl. No.</th>
                  <th style="width: 15%;">Stud. Code</th>
                  <th style="width: 10%;">Roll No.</th>
                  <th style="width: 25%;">Name</th>
                  <th>Total School Days</th>
                  <th>Attendance</th>
                  <th>Percentage</th>
                </thead>
                <tbody>
                  <tr v-for="(student_enrollment, index) in studentsData" :key="student_enrollment.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ student_enrollment.student_code }}</td>
                    <td>{{ student_enrollment.roll_no }}</td>
                    <td>{{ student_enrollment.student.first_name }} {{ student_enrollment.student.last_name }}</td>
                    <td>
                      <a-form-item class="m-0">
                        <a-input
                          type="number"
                          placeholder="Total Days"
                          v-decorator="[`total_school_days[${student_enrollment.id}]`, { initialValue: getInitialTotalSchoolDays(student_enrollment) }]"
                          @change="calculatePercentage(student_enrollment.id)"
                        />
                      </a-form-item>
                    </td>
                    <td>
                      <a-form-item class="m-0">
                        <a-input
                          type="number"
                          placeholder="Attendance"
                          v-decorator="[`attendance[${student_enrollment.id}]`, { initialValue: getInitialAttendance(student_enrollment) }]"
                          :disabled="examData.is_manual_attendance == 0"
                          @change="calculatePercentage(student_enrollment.id)"
                        />
                      </a-form-item>
                    </td>
                    <td class="align-middle">
                      <span :id="`percentage-${student_enrollment.id}`">
                        {{ calculateInitialPercentage(student_enrollment) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ClassExamAttendanceForm',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      examData: null,
      studentsData: [],
      globalTotalSchoolDays: null,
    }
  },
  mounted() {
    this.$eventBus.$on('openClassExamAttendanceForm', this.showModal)
  },
  beforeDestroy() {
    this.$eventBus.$off('openClassExamAttendanceForm', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    showModal(examData, studentsData) {
      this.visible = true
      this.examData = examData
      this.studentsData = studentsData
      this.globalTotalSchoolDays = null

      // Attempt to set a default global total school days from the first student if it exists
      if (this.studentsData.length > 0) {
        const firstStudentDays = this.getInitialTotalSchoolDays(this.studentsData[0])
        if (firstStudentDays) {
          this.globalTotalSchoolDays = firstStudentDays
        }
      }
    },
    getInitialTotalSchoolDays(enrollment) {
      if (enrollment.student_exam && enrollment.student_exam.length > 0) {
        return enrollment.student_exam[0].total_school_days
      }
      return null
    },
    getInitialAttendance(enrollment) {
      if (enrollment.student_exam && enrollment.student_exam.length > 0) {
        return enrollment.student_exam[0].attendance
      }
      return null
    },
    calculateInitialPercentage(enrollment) {
      const totalDays = this.getInitialTotalSchoolDays(enrollment)
      const attendance = this.getInitialAttendance(enrollment)

      if (totalDays && totalDays > 0 && attendance !== null && attendance !== undefined) {
        return ((attendance / totalDays) * 100).toFixed(2) + '%'
      }
      return '--'
    },
    calculatePercentage(enrollmentId) {
      this.$nextTick(() => {
        const values = this.form.getFieldsValue()
        const totalDays = values.total_school_days[enrollmentId]
        const attendance = values.attendance[enrollmentId]

        let displayStr = '--'
        if (totalDays && totalDays > 0 && attendance !== null && attendance !== undefined && attendance !== '') {
          displayStr = ((attendance / totalDays) * 100).toFixed(2) + '%'
        }

        const span = document.getElementById(`percentage-${enrollmentId}`)
        if (span) {
          span.innerText = displayStr
        }
      })
    },
    applyGlobalTotalSchoolDays() {
      if (!this.globalTotalSchoolDays) return

      const newValues = {}
      this.studentsData.forEach(student => {
        newValues[`total_school_days[${student.id}]`] = this.globalTotalSchoolDays
      })

      this.form.setFieldsValue(newValues)

      // Recalculate all percentages
      this.studentsData.forEach(student => {
        this.calculatePercentage(student.id)
      })
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: 'Are you sure?',
            content: 'Do you want to save these attendance records?',
            onOk: () => {
              this.loading = true
              const studentAttendances = []

              this.studentsData.forEach(student => {
                const enrollmentIdVal = student.id
                const totalDaysVal = values.total_school_days[enrollmentIdVal]
                const attendanceVal = values.attendance[enrollmentIdVal]

                // Only add to payload if values changed or we need to update
                // Sending all records is fine since backend handles it quickly
                studentAttendances.push({
                  enrollment_id: enrollmentIdVal,
                  total_school_days: totalDaysVal !== undefined && totalDaysVal !== '' ? totalDaysVal : null,
                  attendance: attendanceVal !== undefined && attendanceVal !== '' ? attendanceVal : null,
                })
              })

              const payload = {
                class_section_exam_id: this.examData.id,
                student_attendances: studentAttendances,
              }

              this.$http
                .post('/api/studentexamattendance/save', payload)
                .then(() => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification.success({
                    message: 'Successfully updated',
                    description: 'Attendance updated successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>

<style scoped>
.neo-exam-attendance-form-table-container {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
